import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
// import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import WarehouseService from "../services/WarehouseService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

const DataTableManagers = ({ listManagers, idWarehouse }) => {
  console.log("listManagers", listManagers);
  const [managers, setManagers] = useState(listManagers);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const { SearchBar } = Search;
  // const MyExportCSV = (props) => {
  //   const handleClick = () => {
  //     props.onExport();
  //   };
  //   return (
  //     <div>
  //       <button className="btn btn-dark" onClick={handleClick}>
  //         <i class="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            WarehouseService.deleteWarehouseManager(
              getCurrentUserId(),
              idWarehouse,
              cell
            )
              .then((response) => {
                console.log("response", response);
                if (response.data["success"]) {
                  setOpenInfoAlert(true);

                  setInfoAlertText("Element supprimé avec succée ");

                  setManagers(managers.filter((dept) => dept.id !== cell));

                  setTimeout(() => {
                    window.location.reload(false);
                  }, 2000);
                } else {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :erreur serveur ");
                }
              })
              .catch((e) => {
                console.log("error", e);
              });
          }}
        >
          <i class="fas fa-trash"></i>
        </button>
      </span>
    );
  }

  const columns = [
    {
      dataField: "cin",
      text: "CIN",
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "firstName",
      text: "Prénom",
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "lastName",
      text: "Nom",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ managers }) {
    return managers;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  return (
    <div>
      {console.log("managers", managers)}
      <ToolkitProvider
        keyField="id"
        data={listManagers}
        columns={columns}
        onTableChange={handleTableChange}
        // exportCSV
        search
      >
        {(props) => (
          <div>
            <div className="row ml-0">
              <div>
                <SearchBar
                  {...props.searchProps}
                  className="custome-search-field"
                  style={{ color: "black" }}
                  placeholder="Chercher"
                ></SearchBar>
              </div>
              <div className="ml-auto mr-0">
                {/* <MyExportCSV {...props.csvProps}></MyExportCSV> */}
              </div>
            </div>
            <div className="row">
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
                // expandRow={expandRow}
              />
            </div>
          </div>
        )}
      </ToolkitProvider>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableManagers;
